exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scheduler-section-container{width:100%}.scheduler-section-container .scheduler-section-flex-items{text-align:center}nylas-scheduling{width:97%;box-shadow:none !important;-ms-flex-preferred-size:fit-content;flex-basis:fit-content}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/template/sections/content/scheduler/styles/scheduler.scss
// module id = 6214
// module chunks = 0